import React from 'react';
import { FULL_VERSION, GIT_HASH, GIT_BRANCH, BUILD_TIME } from '../version';
import config from '../config/environment';

// ============================================================
// VERSION INFO TOGGLE
// Set to true to show version/build info in bottom-right corner
// Useful for debugging deployment issues
// ============================================================
const SHOW_VERSION_INFO = false;

export default function VersionBadge() {
  // Return null if version info is hidden
  if (!SHOW_VERSION_INFO) {
    return null;
  }

  const formatTime = (isoString) => {
    return new Date(isoString).toLocaleString();
  };

  return (
    <div className="fixed bottom-3 right-3 bg-gray-900 text-white p-3 rounded-lg text-xs font-mono z-50 border border-gray-700 shadow-lg">
      <div className="flex flex-col gap-1">
        <div className="font-bold text-blue-400">🔖 v{FULL_VERSION}</div>
        <div className="text-cyan-400">🔗 {GIT_HASH} ({GIT_BRANCH})</div>
        <div className="text-green-400">🌍 {config.environment.toUpperCase()}</div>
        <div className="text-yellow-400">📡 {config.apiBaseUrl}</div>
        <div className="text-purple-400">⏰ {formatTime(BUILD_TIME)}</div>
        <div className="text-gray-400 mt-1 border-t border-gray-700 pt-1">
          {config.environment === 'production' 
            ? '✅ PRODUCTION READY' 
            : '⚠️ NOT PRODUCTION'}
        </div>
      </div>
    </div>
  );
}
